export const SET_CONTACTS_ROUTES = 'routesEpic/SET_CONTACTS_ROUTES';
